import { appConfig } from '@config';
import axiosInstance from '@helpers/api/axiosInstance';
import failErrorResponse from '@helpers/api/httpResponse';
import { setHeaders } from '@helpers/api/setHeaders';
import successResponse from '@helpers/api/successResponse';

/**
 * POST Request.
 * @param {string} path - URL path
 * @param {*} payload - Patch request payload.
 * @param {Object} [$2={}] - Configuration options.
 * @param {string} [$2.baseURL] - Base URL overrides default.
 * @param {Function} [$2.onSuccess=()=>{})] - Onsuccess callback overrides default successResponse
 * @param {Object<string,string>|{}} [$2.additionalHeaders] - Pass additional headers which can overwrite current values
 * @param {Object<string,*>|{}} [$2.axiosOptions] - Extra axios config options
 * @returns {Promise<*>}
 */
const postRequest = async (
  path,
  payload = {},
  {
    baseURL = `${appConfig.apiUrl}/`,
    onSuccess = successResponse,
    onFailure = failErrorResponse,
    axiosOptions = {},
    additionalHeaders = {},
  } = {}
) =>
  axiosInstance
    .post(`${baseURL}${path}`, payload, {
      headers: setHeaders(additionalHeaders),
      ...axiosOptions,
    })
    .then(onSuccess)
    .catch(onFailure);

export default postRequest;
